import { render, staticRenderFns } from "./ClientMeasurement.vue?vue&type=template&id=72c85fe2&scoped=true"
import script from "./ClientMeasurement.vue?vue&type=script&lang=js"
export * from "./ClientMeasurement.vue?vue&type=script&lang=js"
import style0 from "./ClientMeasurement.vue?vue&type=style&index=0&id=72c85fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c85fe2",
  null
  
)

export default component.exports